module.exports = {
        props:{
            apps:Array
        },
        data: function () {
            return {
            }
        },
        methods: {
        },
        components: {
            appWindow:require('components/app-window.vue')
        },
        ready: function () {
        }
    };


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/application.vue
 ** module id = 62
 ** module chunks = 0
 **/